import React from 'react'

const HomePage = () => {
  return (
    <div>This is my homepage</div>
  )
}

export default HomePage